"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchedulingLink = void 0;
function getSchedulingLink(schedulingLink, personId, jobId, clientName) {
    if (schedulingLink && schedulingLink.includes('calendly.com') && personId && jobId) {
        return {
            link: `${schedulingLink}?utm_campaign=${jobId}&utm_source=${personId}&utm_medium=${encodeURIComponent(clientName)}`,
            text: schedulingLink
        };
    }
    else {
        return { link: schedulingLink, text: schedulingLink };
    }
}
exports.getSchedulingLink = getSchedulingLink;
//# sourceMappingURL=scheduling-link-utils.js.map